import React from 'react';
import { useOs } from '@wppopen/react';

import { App } from 'App';

import './styles/main.scss';

export const AppWithOSContext = (props: { propsBaseUrl?: string }) => {
    const OS = useOs();
    let baseUrl = props.propsBaseUrl ? props.propsBaseUrl : OS.osContext.baseUrl;
    return <App baseUrl={baseUrl} />;
};
